module.exports = __webpack_public_path__ + "static/media/charger-pin-private.e93013d0.svg";